<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" style="margin-top: 60px; padding: 15px 0px 0px 0px;"
         id="gdlr-core-wrapper-2">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="background-image: url(static/upload/about-2-about-bg.png); background-repeat: no-repeat; background-position: top center;"
             data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first gdlr-core-hide-in-mobile"
               id="gdlr-core-column-38316">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 50px 40px 0px 0px;">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                     style="background-size: cover; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                       style="padding-bottom: 50px;">
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                      style="border-width: 0px; margin-right: 10px;">
                      <img src="http://cdn-static.huidetrust.com/static/images/2023072602.png" alt="" width="900" height="623" title="img 001">
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-right-align gdlr-core-style-vertical"
                    style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                         style="border-color: #d32525; height: 90px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-7419">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                 style="margin: 0px 0px 110px; padding: 70px 0px 0px 50px; height: 680px;"
                 data-sync-height="height-img">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 40px;">
                        <span
                          class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                          style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                          <span class="gdlr-core-title-item-left-dot"
                                style="width: 5px; height: 5px; background-color: #d32525; margin-right: 15px;"></span>
                          Advantage
                          </span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                        “港籍生”    迈向终身学习的多元出路
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-icon-list-item gdlr-core-item-pdlr gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-style-1"
                    style="padding-bottom: 5px;">
                    <ul>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo01.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            15年免费公立教育
                          </span>
                          <ul>
                            <li>即2-3年的幼儿园学前教育、6年的公立小学教育、6年中学课程</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo02.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            开放式教育
                          </span>
                          <ul>
                            <li>崇尚学术自由和开放式教育，课本题材生活化</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo03.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            英语学习程度高
                          </span>
                          <ul>
                            <li>课堂采用中文、粤语、英语三种语言教学，英语学习程度高</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo01.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            拓展国际视野
                          </span>
                          <ul>
                            <li>对拓展国际视野更有助力，如果未来计划前往英语国家留学，也能更好地过渡衔接。</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo02.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            国际优秀教育资源多
                          </span>
                          <ul>
                            <li>目前香港约有50多所国际学校，大多开设A-Level/IGCSE、AP、IB等课程。</li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
            <h4 style="color: #525252; text-align: center;">内地高考 VS 香港DSE VS 华侨生联考</h4>
            <table>
              <tr>
                <th width="150">类别</th>
                <th>内地高考</th>
                <th>香港DSE</th>
                <th>华侨生联考</th>
              </tr>
              <tr>
                <td>对象</td>
                <td>内地考生</td>
                <td>全球考生</td>
                <td>华侨生/港澳台考生</td>
              </tr>
              <tr>
                <td>考试时间</td>
                <td>6月7日-10日</td>
                <td>3月初-5月底</td>
                <td>5月第三个周末</td>
              </tr>
              <tr>
                <td>考试地点</td>
                <td>对应报考地区</td>
                <td>香港；2024年起内地设考点</td>
                <td>港澳台及内地</td>
              </tr>
              <tr>
                <td>考试科目</td>
                <td>文科：语文、数学、英语、政治、历史、地理<br/>理科：语文、数学、英语、物理、化学、生物</td>
                <td>核心科目：语文、英语、数学、公民与社会发展<br/> 选修科目：历史、化学、物理、经济、M1等20多科</td>
                <td>文科：语文、数学、英语、历史、地理<br/>理科：语文、数学、英语、物理、化学</td>
              </tr>
              <tr>
                <td>考试难度</td>
                <td>极高</td>
                <td>考试范围较广</td>
                <td>70%初中知识；30%高中知识</td>
              </tr>
              <tr>
                <td>分数设置</td>
                <td>满分750分</td>
                <td>满分42分</td>
                <td>满分750</td>
              </tr>
              <tr>
                <td>考试出路</td>
                <td>主要用于内地升学<br/>国际认可度不高</td>
                <td>国际认可度高 全球超300所海外名校认可香港DSE成绩<br/>2022年内地超130所高校免招香港DSE学生 港籍生有80%名额配比</td>
                <td>以联考升读内地大学，超300所院校接受，211保底<br/>升读香港大学录取分数与内地高考差不多</td>
              </tr>
              <tr>
                <td>偏科情况</td>
                <td>不允许</td>
                <td>允许</td>
                <td>允许</td>
              </tr>
              <tr>
                <td>成绩和有效期</td>
                <td>考试当年短暂有效</td>
                <td>2年有效<br/>综合各科最高分数申请</td>
                <td>考试当年短暂有效</td>
              </tr>
              <tr>
                <td>2023报考人数</td>
                <td>1291万</td>
                <td>5.08万</td>
                <td>7238 </td>
              </tr>
              <tr>
                <td>2022录取情况</td>
                <td>985、211录取率约1%-3%</td>
                <td>港八大院校录取率（本地生）约40%</td>
                <td>211录取率约47.6%</td>
              </tr>
            </table>
          </div>
          <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
            <h4 style="color: #525252; text-align: center;">香港国际学校排名 排名以世界前20名大学录取率为准</h4>
            <table>
              <tr>
                <th>排名</th>
                <th>学校名称</th>
                <th>IB平均分(满分45分)</th>
                <th>世界前20大学录取率</th>
              </tr>
              <tr>
                <td>1</td>
                <td>德瑞国际学校</td>
                <td>41</td>
                <td>24%</td>
              </tr>
              <tr>
                <td>2</td>
                <td>汉基国际学校</td>
                <td>40.89</td>
                <td>14%</td>
              </tr>
              <tr>
                <td>3</td>
                <td>香港李宝椿联合世界书院</td>
                <td>35.9</td>
                <td>13%</td>
              </tr>
              <tr>
                <td>4</td>
                <td>哈罗香港国际学校</td>
                <td>/</td>
                <td>12%</td>
              </tr>
              <tr>
                <td>5</td>
                <td>弘立书院</td>
                <td>41</td>
                <td>11%</td>
              </tr>
              <tr>
                <td>6</td>
                <td>香港国际学校</td>
                <td>/</td>
                <td>11%</td>
              </tr>
              <tr>
                <td>7</td>
                <td>法国国际学校</td>
                <td>37.92</td>
                <td>9%</td>
              </tr>
              <tr>
                <td>8</td>
                <td>启历学校</td>
                <td>/</td>
                <td>7%</td>
              </tr>
              <tr>
                <td>9</td>
                <td>南岛中学</td>
                <td>37.1</td>
                <td>5%</td>
              </tr>
              <tr>
                <td>10</td>
                <td>香港加拿大国际学校</td>
                <td>39</td>
                <td>4%</td>
              </tr>
              <tr>
                <td>11</td>
                <td>港岛中学</td>
                <td>38.5</td>
                <td>3%</td>
              </tr>
              <tr>
                <td>12</td>
                <td>英皇佐治五世学校</td>
                <td>37.8</td>
                <td>3%</td>
              </tr>
              <tr>
                <td>13</td>
                <td>沪江维多利亚学校</td>
                <td>37.3</td>
                <td>2%</td>
              </tr>
              <tr>
                <td>14</td>
                <td>西岛中学</td>
                <td>38.2</td>
                <td>2%</td>
              </tr>
              <tr>
                <td>15</td>
                <td>耀中国际学校</td>
                <td>37.3</td>
                <td>2%</td>
              </tr>
              <tr>
                <td>16</td>
                <td>美国国际学校</td>
                <td>/</td>
                <td>1%</td>
              </tr>
              <tr>
                <td>17</td>
                <td>英基沙田学院</td>
                <td>40</td>
                <td>1%</td>
              </tr>
              <tr>
                <td>18</td>
                <td>圣保罗男女中学（IB学校）</td>
                <td>43.1</td>
                <td>/</td>
              </tr>
              <tr>
                <td>19</td>
                <td>拔萃男书院（IB班）</td>
                <td>42</td>
                <td>/</td>
              </tr>
              <tr>
                <td>20</td>
                <td>新加坡国际学校</td>
                <td>40</td>
                <td>/</td>
              </tr>
              <tr>
                <td>21</td>
                <td>保良局蔡继有学校</td>
                <td>37.79</td>
                <td>/</td>
              </tr>
              <tr>
                <td>22</td>
                <td>真道书院（IB课程）</td>
                <td>39.5</td>
                <td>/</td>
              </tr>
              <tr>
                <td>23</td>
                <td>启新书院</td>
                <td>38</td>
                <td>/</td>
              </tr>
              <tr>
                <td>24</td>
                <td>英基智新书院</td>
                <td>36.1</td>
                <td>/</td>
              </tr>
              <tr>
                <td>25</td>
                <td>香港诺德安达国际学校</td>
                <td>35.1</td>
                <td>/</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <br/>
    <br/>
    <br/>
    <!-- 分割线 -->
    <div class="gdlr-core-pbf-section">
      <div class="gdlr-core-pbf-section-container gdlr-core-container clearfix">
        <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-60251" style="z-index: 9;">
          <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="margin: -45px 0px -65px 0px; padding: 0px 0px 0px 0px;">
            <div class="gdlr-core-pbf-background-wrap"></div>
            <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
              <div class="gdlr-core-pbf-element">
                <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align" style="margin-bottom: 0px;">
                  <div class="gdlr-core-divider-container" style="max-width: 1px;"><div class="gdlr-core-divider-line gdlr-core-skin-divider" style="border-color: #d32525; border-width: 100px;"></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ServiceContent5'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/service/ServiceContent5.vue